import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '@qover/molecules';
import messages from './summaryTerms.messages';
import {
  SummaryTermsSectionContainer,
  InnerContainer,
  ActionContainer,
} from './summaryTermsSection.styles';

type SummaryTermsSectionProps = {
  children: React.ReactNode;
  showButton?: boolean;
};

export function SummaryTermsSection(props: SummaryTermsSectionProps) {
  const { showButton = true, children } = props;

  return (
    <SummaryTermsSectionContainer>
      <h4>{messages.termsOfService}</h4>
      <InnerContainer>
        {children}
        {showButton && (
          <ActionContainer>
            <PrimaryButton data-test="bottomNav.continue">
              {messages.continue}
            </PrimaryButton>
          </ActionContainer>
        )}
      </InnerContainer>
    </SummaryTermsSectionContainer>
  );
}
